var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useCallback, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from '@/hooks/lib/react-router/useNavigate';
import { apiCreateProffitSearchGroup, apiGetProffitSearchGroup, } from '../../../../actions/ProffitSearchGroupAction';
import { apiGetOneProfile } from '../../../../actions/ProfileActions';
import { wrapDispatch, wrapNotifyError, notify, } from '../../../../helpers/action';
import { propShape } from '../../../../helpers/custom-prop-types';
import { compose } from '../../../../helpers/recompose';
import { useBoolState, useUnmountRef } from '../../../../helpers/use/useHook';
import Layout from '../../../Layout';
import Breadcrumb from '../../../Layout/Breadcrumb';
import AuthenticationHoc from '../../../System/AuthenticationHoc';
import ProffitSearchTutorialHoc from '../../../Ui/ProffitSearch/Hoc/ProffitSearchTutorialHoc';
import ProffitSearchGroupHoc from '../../Common/Hoc/ProffitSearchGroupHoc';
import AccountForm from './Parts/AccountAdd/AccountForm/AccountForm';
const AccountAddInner = (props) => {
    const { group } = props;
    const { admin, billingInformation = [], list: members = [] } = group || {};
    const enableMembers = useMemo(() => [...members].filter((v) => v.hasUser && !v.isDisabled), [members]);
    const profile = useSelector((state) => state.profile);
    const { email, enableDomains = [] } = profile;
    const pans = useMemo(() => [
        {
            link: '/mypage',
            text: 'マイページ',
        },
        {
            link: '/proffit_search',
            text: 'PROFFIT SEARCH',
        },
        {
            text: 'メンバー追加',
        },
    ], []);
    // 自分が購入していない場合は自分のアカウントが必ず最初に表示する
    const { hasAccount, initialValues } = useMemo(() => {
        const memoHasAccount = !!members.find((v) => v.email === email);
        return {
            hasAccount: memoHasAccount,
            initialValues: {
                admin: admin ? admin.email : '',
                billingInformation,
                members: [{ email: memoHasAccount ? '' : email }],
            },
        };
    }, [admin, members, billingInformation, email]);
    const { boolState: modalState, changeFalse: hideModal, changeTrue: showModal, } = useBoolState(false);
    const dispatch = useDispatch();
    const unmountRef = useUnmountRef();
    const history = useNavigate();
    const onSubmit = useCallback((values) => __awaiter(void 0, void 0, void 0, function* () {
        yield wrapNotifyError(() => __awaiter(void 0, void 0, void 0, function* () {
            const { admin: submitAdmin, billingInformation: submitBillingInformation = [], members: submitMembers, } = values;
            const params = {
                adminEmail: submitAdmin,
                billingInformation: submitBillingInformation,
                members: submitMembers.map((member) => member.email),
            };
            yield wrapDispatch(dispatch, apiCreateProffitSearchGroup(params));
            if (!unmountRef.current) {
                yield Promise.all([
                    wrapDispatch(dispatch, apiGetProffitSearchGroup()),
                    wrapDispatch(dispatch, apiGetOneProfile()),
                ]);
                notify('メンバーを追加しました');
                history.push('/proffit_search/account_list');
            }
        }));
    }), [dispatch, history, unmountRef]);
    const [emailStates, changeEmailStates] = useState({});
    const [expiredStates, changeExpiredStates] = useState({});
    const unMountRef = useUnmountRef();
    return (_jsx(Layout, Object.assign({ headerType: 'proffit_search', mainClassName: 'l-main slide_search_page slide_search_mypage_account_add_page', stickyClassName: 'slide_search_page' }, { children: _jsxs("div", Object.assign({ className: 'l-container' }, { children: [_jsx(Breadcrumb, { lists: pans }), _jsxs("div", Object.assign({ className: 'mypage_container' }, { children: [_jsx("div", Object.assign({ className: 'proffit_search_account_card_title' }, { children: "\u30E1\u30F3\u30D0\u30FC\u3092\u8FFD\u52A0\u3059\u308B" })), _jsx("div", Object.assign({ className: 'mypage_content' }, { children: _jsx(AccountForm, { changeEmailStates: changeEmailStates, changeExpiredStates: changeExpiredStates, emailStates: emailStates, enableDomains: enableDomains, enableMembers: enableMembers, expiredStates: expiredStates, hasAccount: hasAccount, hideModal: hideModal, initialValues: initialValues, modalState: modalState, onSubmit: onSubmit, showModal: showModal, unMountRef: unMountRef }) }))] }))] })) })));
};
AccountAddInner.propTypes = {
    group: propShape().isRequired,
};
const AccountAdd = compose(AuthenticationHoc({ isCanUseProffitSearch: true }), ProffitSearchGroupHoc(), ProffitSearchTutorialHoc())(AccountAddInner);
export default AccountAdd;
